export default __webpack_public_path__ + "static/media/2.18761331.jpg";